import { ArrowLeftIcon, useScopedSelector } from 'ia-react-core';
import { ResourcesLoader } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NewsDetailsResource from '../../components/NewsDetailsResource';
import Constants from '../../Constants';
import Details from './Details';
import { StyledLink } from './NewsDetailsPage.styles';
import { NewsDetails } from '../../interfaces/NewsDetails';
import { NewsDetailsResourceInfo } from '../../components/NewsDetailsResource/NewsDetailsResource';

export interface NewsDetailsPageProps {
}

const NewsDetailsPage: FC<NewsDetailsPageProps> = () => {
  const newsDetails: NewsDetails = useScopedSelector(NewsDetailsResourceInfo.dataDst);
  const { state } = useLocation() as { state: { currentPage: number } };
  const { t } = useTranslation('NewsDetailsPage');
  const currentPage = state?.currentPage || 1;

  return (
    <ResourcesLoader>
      <ResourcesLoader.Resources>
        <NewsDetailsResource autoRequest requestOnLanguageChange />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <Helmet>
          <title>{newsDetails?.Title}</title>
        </Helmet>
        <StyledLink data-testid="BackToAllNewsLink" LeftIcon={ArrowLeftIcon} redirectTo={`${Constants.BasePagePath}?page=${currentPage}`}>
          {t('link')}
        </StyledLink>
        <Details newsDetails={newsDetails} />
      </ResourcesLoader.Content>
    </ResourcesLoader>

  );
};

export default (NewsDetailsPage);
